import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import * as sweetalert from 'sweetalert';
import { LocalStorageService } from 'ngx-webstorage';

import { Usuario } from '../Models/Usuario';
import { Resultado } from '../Models/Resultado';

import { UsuarioService } from '../services/usuario.service';
import { GlobalsService } from '../services/globals.service';
import { UtilesService } from '../services/utiles.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {



  public resultado: Resultado = new Resultado();

  public email: string;
  public password: string;

  public usuario: Usuario;

  public returnUrl: string;

  public version: String = "";

  constructor(
    private route: ActivatedRoute,
    private usuarioService: UsuarioService,
    private globalServices: GlobalsService,
    private router: Router,
    private storage: LocalStorageService,
    private utilesService: UtilesService) {

  }

  ngOnInit() {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    this.version = this.utilesService.NumeroVersion();
  }


  validarIngreso() {
    try {

      try {


        const validacion = new Usuario();

        validacion.email = this.email;
        validacion.contrasena = btoa(this.password);


        this.usuarioService.ValidarAcceso(validacion).subscribe(
          data => {
            this.resultado = data;

            if (data.tipoResultado == "ERROR") {
              swal(data.mensaje, "", "error");
              return;
            }

            if (data.objetoResultado.tipoUsuario === "Transportista") {
              swal("Usuario no cuenta con permisos", "", "error");
              return;
            }

            if (data.tipoResultado.toUpperCase() === "OK") {

              this.storage.store("sesion", btoa(JSON.stringify(data.objetoResultado)))


              let usuario = localStorage.getItem('sesion');

              this.router.navigate([this.returnUrl]);


            }

          },
          err => {
            console.clear();
            console.log(err._body);

          });


      } catch (error) {
        console.log("CargarVehiculos: " + error);
      }

    } catch (error) {
      console.error(error);
    }
  }

}
